import { Col, Row } from 'reactstrap';

import CondicionalLookup from 'src/lookups/condicional';
import CollapsibleSection from 'src/componentes/CollapsibleSection';
import { COLABORADOR_CAMPOS } from 'src/utils/constants';

import { hasSearchMatch } from './searchUtils';

const DivulgacaoAniversarioSection = ({ model, intl, campos, searchQuery }) => {
  if (!campos[COLABORADOR_CAMPOS.AUTORIZACAO_DIVULGACAO_ANIVERSARIO]) return null;

  const fieldMatches = (terms) => hasSearchMatch(searchQuery, terms);
  const sectionTerms = [intl.formatMessage({ id: 'autorizacaoDivulgacaoAniversario' })];

  if (!hasSearchMatch(searchQuery, sectionTerms)) return null;

  return (
    <CollapsibleSection title={intl.formatMessage({ id: 'autorizacaoDivulgacaoAniversario' })}>
      <Row>
        {fieldMatches([intl.formatMessage({ id: 'autorizacaoDivulgacaoAniversario' })]) && (
          <Col md={12}>
            <CondicionalLookup clearable model={model.getModel('autorizacaoDivulgacaoAniversario')} />
          </Col>
        )}
      </Row>
    </CollapsibleSection>
  );
};

export default DivulgacaoAniversarioSection;
